<template>
  <div class="testimonial slide-in-on-scroll" v-observe-visibility="observeVisibilityOptions">
    <div class="testimonial-text">{{ text }}</div>
    <div class="quote quote-left">
      <font-awesome-icon icon="quote-left" class="icon" />
    </div>
    <div class="quote quote-right">
      <font-awesome-icon icon="quote-right" class="icon" />
    </div>
  </div>
</template>

<script>
import visibilityChange from "@/mixins/visibility-change";

export default {
  mixins: [visibilityChange],
  props: {
    text: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.testimonial {
  border-radius: 2rem;
  border: 0.2rem rgb(167, 203, 103) solid;
  padding: 2.5rem 4rem;
  position: relative;
}

.quote {
  position: absolute;
  background: white;
  height: 4rem;
  width: 4rem;
  font-size: 2.5rem;
  color: rgb(167, 203, 103);
}

.quote-left {
  left: -0.2rem;
  top: -0.2rem;
}

.quote-right {
  bottom: -0.2rem;
  right: -0.2rem;
  display: flex;
  justify-content: end;
  align-items: end;
}

.testimonial-text {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 300;
}
</style>
